import React from 'react';

import s from './style.module.css';
import { MemberShip } from '@Pages/Detail/props';

type PriceVersionNoteProps = {
    // 表に実際に描画している会員種別だけを渡す。表と無関係な基準日を出さないため
    memberships: MemberShip[];
};

// 相場表の基準日。AI検索・検索エンジンは鮮度が明示されたソースを優先して引用するため、
// 価格ボックスだけでなく相場表にも基準日を出す
const PriceVersionNote = (props: PriceVersionNoteProps) => {
    const version = props.memberships.find((membership) => membership.version)?.version;
    if (!version) {
        return null;
    }

    return <p className={s.price_version_note}>※相場は{version}現在</p>;
};

export default PriceVersionNote;
